<div class="sar-contentBox">
  <h2 class="heading content-top">All SARs</h2>
  <section class="order-component">
    <ng-template #template let-anchor>
      <span>{{ anchor.nativeElement.innerText }}</span>
    </ng-template>
    <div class="grid-box" kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
      (mouseover)="showTooltip($event)">
      <kendo-grid [data]="gridView" [loading]="loadingPanelVisible" [resizable]="true" [filterable]="true"
                  [groupable]="true" [group]="groups" (groupChange)="groupChange($event)" [pageSize]="pageSize" [skip]="skip"
                  [filter]="filters" [sortable]="true" [pageable]="{
    buttonCount: buttonCount,
    info: info,
    pageSizes: pageSizes,
    previousNext: previousNext }" [sortable]="{
    allowUnsort: allowUnsort,
    mode: multiple ? 'multiple' : 'single'
    }" [sort]="sort" (dataStateChange)="dataStateChange($event)" class="kendo-grid">

        <ng-template kendoGridToolbarTemplate>
          <kendo-grid-spacer></kendo-grid-spacer>
          <button style="height:28px;" type="button" class="sm row align-items-center"
                  [ngClass]="{'excelData' : totalRecords > 0 , 'noExcelData': totalRecords ==0}" (click)="exportRecords()">
            <span class="k-icon k-font-icon k-i-file-excel"></span>Export to Excel
          </button>
        </ng-template>
        <kendo-grid-column [width]="150" field="sarId" title="SAR ID">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <a href="javascript:void(0);" (click)="manage(dataItem.id)">{{dataItem.sarId}}</a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="businessUnit" title="Business Unit">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="title" title="Title">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="actionNumber" [filterable]="false" title="Action Number ">
          <!-- number -->
          <ng-template kendoGridCellTemplate let-dataItem>
            <a href="javascript:void();" (click)="navViewAction(dataItem)">{{dataItem.actionNumber}}</a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="action" title="Action ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="supplier" title="Supplier" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="supplierNumber" title="Supplier Number" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="priority" title="Priority ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="branchPlant" title="Branch/Plant" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="owner" title="Owner ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="createdOn" title="Created On " format="{0:dd/MM/yyyy}">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
              <kendo-filter-eq-operator></kendo-filter-eq-operator>
              <kendo-filter-gte-operator></kendo-filter-gte-operator>
              <kendo-filter-lte-operator></kendo-filter-lte-operator>
            </kendo-grid-date-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="description" title="Description ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="manufacturer" title="Manufacturer " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="manufacturerPartNumber" title="Manufacturer Part Number "
                           *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="uom" title="UOM ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="segment" title="Segment " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="mrp" title="MRP ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="lineNumber" [filterable]="false" title="line Number ">
          <!-- number -->
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="materialNumber" title="Material Number ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="materialGroupCode" title="Material Group Code "
                           *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="shortDescription" title="Short Description " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="enrichedDescription" title="Enriched Description "
                           *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="dataChangeType" title="Data Change Type " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="newData" title="New Data " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="plant" title="Plant " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="plantDF" title="Plant DF " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="storageLocation" title="Storage Location " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="storageLocationDF" title="Storage Location DF "
                           *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="recommendedMin" title="Recommended Min " [filterable]="false"
                           *ngIf="buName !== 'ABU'">
          <!-- Number -->
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="recommendedMax" title="Recommended Max " [filterable]="false"
                           *ngIf="buName !== 'ABU'">
          <!-- Number -->
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="valuationType" title="Valuation Type " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="valuationTypeDF" title="Valuation Type DF " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="bin" title="Bin " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="status" title="Status ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="submittedBy" title="Submitted By " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" filter="date" field="submittedOn" title="Submitted On "
                           *ngIf="buName !== 'ABU'">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
              <kendo-filter-eq-operator></kendo-filter-eq-operator>
              <kendo-filter-gte-operator></kendo-filter-gte-operator>
              <kendo-filter-lte-operator></kendo-filter-lte-operator>
            </kendo-grid-date-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="lastModified" title="Last Modified" format="{0:dd/MM/yyyy}" *ngIf="buName === 'ABU'">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
              <kendo-filter-eq-operator></kendo-filter-eq-operator>
              <kendo-filter-gte-operator></kendo-filter-gte-operator>
              <kendo-filter-lte-operator></kendo-filter-lte-operator>
            </kendo-grid-date-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="modifiedBy" title="Modified By" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="assignedTo" title="Assigned To ">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="estimated" title="Unit/Estimated Annual Usage" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="totalMinimum" title="Total Minimum" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="totalMaximum" title="Total Maximum" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="annualUsageForecast" title="Annual Usage Forecast"
                           *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="changeInValue" title="Change In Value" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="totalValue" title="Total Value" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="qaCode" title="QA Code" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="isModelUpdateRequired" title="3D" *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="equipmentCriticality" title="Equipment Criticality"
                           *ngIf="buName === 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="assignedGroup" title="Assigned Group " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="approvedBy" title="Approved By " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="approvedOn" title="Approved On " format="{0:dd/MM/yyyy}"
                           *ngIf="buName !== 'ABU'">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
              <kendo-filter-eq-operator></kendo-filter-eq-operator>
              <kendo-filter-gte-operator></kendo-filter-gte-operator>
              <kendo-filter-lte-operator></kendo-filter-lte-operator>
            </kendo-grid-date-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="closedBy" title="Closed By " *ngIf="buName !== 'ABU'">
          <ng-template class="filtercell" kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
              <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
              <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="150" field="closedOn" title="Closed On " format="{0:dd/MM/yyyy}"
                           *ngIf="buName !== 'ABU'">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
              <kendo-filter-eq-operator></kendo-filter-eq-operator>
              <kendo-filter-gte-operator></kendo-filter-gte-operator>
              <kendo-filter-lte-operator></kendo-filter-lte-operator>
            </kendo-grid-date-filter-cell>
          </ng-template>
        </kendo-grid-column>

      </kendo-grid>


    </div>

  </section>
</div>
